import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import environment from './environment/environment';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//NOTE: React.StrictMode intentially invokes functions passed to useState, useMemo, or useReducer twice.
//      This is why we see controls getting rendered twice. This should only be used for development.

root.render(
  <React.StrictMode>
    <BrowserRouter basename={environment.basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();